import React, { useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useSnackbar } from 'notistack';
import { DialogActions, DialogContent, FormHelperText } from '@mui/material';
import CBButton from '../../../../components/Buttons/CbButton';
import { delayedEvent } from '../../../../utils/eventUtils';
import { deleteLicense } from '../Modals/surplusServices';

export const DeleteSurplusLicense = ({ close, data }: any) => {
  const [backendError, setBackendError] = useState('');
  const { handleSubmit, ...methods } = useForm();
  const { enqueueSnackbar } = useSnackbar();

  function onSubmit() {
    deleteLicense({ id: data.id })
      .then(() => {
        enqueueSnackbar('Surplus License deleted succesfully!', {
          variant: 'success',
        });
        close();
        delayedEvent('table-refetch', 500, 'surplusLicense');
      })
      .catch((error: any) => {
        setBackendError(error.statusText);
      });
  }

  return (
    <>
      <FormProvider {...methods} handleSubmit={handleSubmit}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent className="modal-title" style={{ fontWeight: 600 }}>
            {`Are you sure you want to delete Surplus License ${data.surplusLicenseNumber}?`}
          </DialogContent>
          <FormHelperText className="api-text-error">
            {backendError}
          </FormHelperText>
          <DialogActions>
            <CBButton onClick={close} styleName="cancel">
              Cancel
            </CBButton>
            <CBButton type="submit" styleName="ctaButton">
              Delete
            </CBButton>
          </DialogActions>
        </form>
      </FormProvider>
    </>
  );
};

export default DeleteSurplusLicense;
